
const FinancingConfig = {
    newRates: {
        effectiveDate: '', // Effective date of new rates. Set to empty string if there are no new rates scheduled
        stateGeoIds: [], // States where new rates will be made avaialble. Set to empty array if there are no new rates scheduled
    },
};

export default FinancingConfig;



// WEBPACK FOOTER //
// ./src/app/config/app.financing.config.js